/**
 * FreeSpinsIntroOutroView
 *
 * Handles the view functionality of the free spins dialog(s)
 */
(function () {
  class FreeSpinsIntroOutro extends PIXI.Container {
    constructor() {
      super();

      this._callback = undefined;

      this.visible = false;

      this._spinsWon = undefined;
      this._cashWon = undefined;
      this.__cashWonContainer = undefined;

      this._freeSpinsText = undefined;
      this._fromFreeSpinsText = undefined;

      this._pressStartBox = undefined;
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._spinsWon = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:numFreeSpinsText"
      );
      this._spinsWon.visible = false;

      this._cashWonContainer = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:cashWonTextContainer"
      );

      this._cashWon = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:cashWonTextContainer:cashWonText"
      );
      this._cashWon.visible = false;

      this._freeSpinsText = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:freespinsText"
      );
      this._freeSpinsText.visible = false;

      this._fromFreeSpinsText = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:fromFreespinsText"
      );
      this._fromFreeSpinsText.visible = false;

      this._pressStartBox = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:pressStartColourBox"
      );

      const border = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:gambleBorder"
      );

      const maskSize = { width: 672, height: 456 };
      const mask = new PIXI.Graphics();
      mask.beginFill(0xffffff);
      mask.drawRect(
        -maskSize.width / 2,
        -maskSize.height / 2,
        maskSize.width,
        maskSize.height
      );
      mask.endFill();
      border.addChild(mask);

      this._spotlight0 = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:spotlight0"
      );
      this._spotlight0.alpha = 0.5;
      this._spotlight0.mask = mask;
      this._spotlight0.rotation = 0;
      this._spotlightRotationAnim0 = gsap.to(this._spotlight0, {
        paused: true,
        duration: 20,
        rotation: Math.PI * 2,
        repeat: -1,
        ease: "none",
      });

      this._spotlight1 = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:spotlight1"
      );
      this._spotlight1.alpha = 0.5;
      this._spotlight1.mask = mask;
      this._spotlight1.rotation = 0;
      this._spotlightRotationAnim1 = gsap.to(this._spotlight1, {
        paused: true,
        duration: 20,
        rotation: -Math.PI * 2,
        repeat: -1,
        ease: "none",
      });

      this._panelSparkleEmitter = particleManager.createEmitter(
        "panelSparkleEmitter",
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:particlesContainer",
        0,
        0,
        false
      );
      this._panelSparkleEmitter.particleEmitter.emit = false;
      this._panelSparkleEmitter.visible = false;

      this._pressStartBox.alpha = 0;
      this._pressStartBox.visible = false;
      this._pressStartBox.interactive = false;

      this._spinsWonAnim = gsap.to(this._spinsWon, {
        duration: 3,
        pixi: { scaleX: 1.15, scaleY: 1.15 },
        ease: "power1.inOut",
        repeat: -1,
        yoyo: true,
      });

      this._cashWonAnim = gsap.to(this._cashWonContainer, {
        duration: 3,
        pixi: { scaleX: 1.15, scaleY: 1.15 },
        ease: "power1.inOut",
        repeat: -1,
        yoyo: true,
      });
    }

    setup() {
      resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro"
      ).visible = true;

      // wait for click - anywhere on screen
      this._pressStartBox.visible = true;
      this._pressStartBox.alpha = 0;
      this._pressStartBox.interactive = true;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart =
        this.closeDialog.bind(this);
    }

    showIntro(numFS, callback) {
      this.setup();

      musicManager.onFreeSpinsCollect();

      this._spinsWonAnim.play(0);
      this._spotlightRotationAnim0.play(0);
      this._spotlightRotationAnim1.play(0);
      this._panelSparkleEmitter.particleEmitter.emit = true;
      this._panelSparkleEmitter.visible = true;

      this._callback = callback;

      this._spinsWon.visible = true;
      this._cashWon.visible = false;

      this._freeSpinsText.visible = true;
      this._fromFreeSpinsText.visible = false;

      this._spinsWon.text = numFS;

      soundManager.play("freeSpinsIntro");
    }

    showOutro(cashWon, callback) {
      this.setup();

      this._cashWonAnim.play(0);
      this._spotlightRotationAnim0.play(0);
      this._spotlightRotationAnim1.play(0);
      this._panelSparkleEmitter.particleEmitter.emit = true;
      this._panelSparkleEmitter.visible = true;

      this._callback = callback;

      this._spinsWon.visible = false;
      this._cashWon.visible = true;

      this._freeSpinsText.visible = false;
      this._fromFreeSpinsText.visible = true;

      this._cashWon.setText(gdk.formatCurrency(cashWon));
      soundManager.play("freeSpinsOutro");
    }

    closeDialog() {
      this._spinsWonAnim.pause();
      this._cashWonAnim.pause();
      this._spotlightRotationAnim0.pause();
      this._spotlightRotationAnim1.pause();
      this._panelSparkleEmitter.particleEmitter.emit = false;
      this._panelSparkleEmitter.visible = false;

      soundManager.stop("freeSpinsIntro");
      this._pressStartBox.visible = false;
      this._pressStartBox.alpha = 0;
      this._pressStartBox.interactive = false;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart =
        undefined;

      resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro"
      ).visible = false;

      soundManager.play("buttonPressed");

      this._callback();
    }
  }

  let freeSpinsIntroOutroCreator = function (json) {
    return new FreeSpinsIntroOutro();
  };

  let freeSpinsIntroOutroInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };

  let freeSpinsIntroOutroFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "FreeSpinsIntroOutro",
    freeSpinsIntroOutroCreator,
    freeSpinsIntroOutroInitialiser,
    freeSpinsIntroOutroFilesRequired
  );
})();
